import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const UserCheckIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 68 68">
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <path
              d="M0 0L68 0 68 68 0 68z"
              transform="translate(-48 -2784) translate(48 2551) translate(0 233)"
            />
            <g fill="#EDC14F" fillRule="nonzero">
              <path
                d="M17 36.833l8.5-8.33c-1.105-.113-1.927-.17-2.833-.17C15.102 28.333 0 32.13 0 39.667v5.666h25.5l-8.5-8.5zm5.667-14.166C28.928 22.667 34 17.595 34 11.333 34 5.072 28.928 0 22.667 0c-6.262 0-11.334 5.072-11.334 11.333 0 6.262 5.072 11.334 11.334 11.334M35.332 46.75L25.5 36.833 29.467 32.838 35.332 38.732 49.867 24.083 53.833 28.078z"
                transform="translate(-48 -2784) translate(48 2551) translate(0 233) translate(8.5 11.333)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default UserCheckIcon;
